var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-wrapper"},[(_vm.logoUrl)?_c('object',{attrs:{"data":_vm.logoUrl,"type":_vm.logoFileType}}):_c('div',{staticClass:"placeholder"})])}
var staticRenderFns = []

export { render, staticRenderFns }